import PdfHeader from "../../../../components/pafHeader";
import "./lawyerProfileReport.scss";
import { formatPhoneNumber } from "../../../../utils/appUtils";

const LawyerProfileReport = ({ lawyerData, profileImageUrl }) => {
    return (
        <div className="report-container lawyer-report-container">
            <PdfHeader pdfName="Requested Lawyer" />
            <div style={{ padding: '10px' }}>
                <div className="lawyer-profile-header">
                    <div className="lawyer-profile-information-report">
                        <div className="lawyer-profile-picture">
                            <img src={profileImageUrl || lawyerData?.profileImage} alt="" style={{borderRadius: '50%'}} />
                        </div>
                        <div className="lawyer-name-section">
                            <h2>{lawyerData?.salutation} {lawyerData?.lawyerName || 'Nil'}</h2>
                        </div>
                    </div>
                    <div className="lawyer-info-section">
                        <div className="lawyer-info-grid">
                            <div className="info-item">
                                <div className="label">Mobile Number</div>
                                <div className="value">{lawyerData?.phone ? formatPhoneNumber(lawyerData?.phone) : 'Nil'}</div>
                            </div>
                            <div className="info-item">
                                <div className="label">E-mail Address</div>
                                <div className="value">{lawyerData?.email || 'Nil'}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="professional-details-section">
                <h3 className="section-title">Professional Details</h3>
                <div className="professional-grid">
                    <div className="professional-item">
                        <div className="professional-label">Bar Council Id</div>
                        <div className="professional-value">{lawyerData?.barId || 'Nil'}</div>
                    </div>
                    <div className="professional-item">
                        <div className="professional-label">Specialization</div>
                        <div className="professional-value">{Array.isArray(lawyerData?.specializations) ? lawyerData?.specializations.join(', ') : lawyerData?.specializations || 'Nil'}</div>
                    </div>
                    <div className="professional-item">
                        <div className="professional-label">Experience</div>
                        <div className="professional-value">{lawyerData?.experience || 'Nil'}</div>
                    </div>
                    <div className="professional-item">
                        <div className="professional-label">Qualification</div>
                        <div className="professional-value">{lawyerData?.qualification || 'Nil'}</div>
                    </div>

                </div>
            </div>
            <div className="professional-details-section">
                <h3 className="section-title">Personal Details</h3>
                <div className="professional-grid">
                    <div className="professional-item">
                        <div className="professional-label">Address 1</div>
                        <div className="professional-value">{lawyerData?.address1 || 'Nil'}</div>
                    </div>
                    <div className="professional-item">
                        <div className="professional-label">Address 2</div>
                        <div className="professional-value">{lawyerData?.address2 || 'Nil'}</div>
                    </div>
                    <div className="professional-item">
                        <div className="professional-label">State</div>
                        <div className="professional-value">{lawyerData?.state || 'Nil'}</div>
                    </div>
                    <div className="professional-item">
                        <div className="professional-label">District</div>
                        <div className="professional-value">{lawyerData?.district || 'Nil'}</div>
                    </div>
                    <div className="professional-item">
                        <div className="professional-label">City</div>
                        <div className="professional-value">{lawyerData?.city || 'Nil'}</div>
                    </div>
                    <div className="professional-item">
                        <div className="professional-label">Pincode</div>
                        <div className="professional-value">{lawyerData?.pincode || 'Nil'}</div>
                    </div>
                </div>
            </div>

            <div className="bio-section">
                <h3 className="section-title">Bio / About You</h3>
                <p className="bio-text">{lawyerData?.about || 'Nil'}</p>
            </div>
            <div className="report-footer">1</div>
        </div>
    );
};

export default LawyerProfileReport;